import {
  Building2,
  CalendarRange,
  FolderTree,
  Globe,
  GraduationCap,
  Layers,
  type LucideIcon,
  MapPin,
  Trophy,
  Users,
} from "lucide-react";

import type { OrgUnitType } from "./types";

/** Every type identity accepts has a label, so a type it adds fails to compile here. */
export const ORG_UNIT_TYPE_LABELS = {
  org: { label: "Organization", icon: Building2 },
  division: { label: "Division", icon: Layers },
  department: { label: "Department", icon: FolderTree },
  team: { label: "Team", icon: Users },
  region: { label: "Region", icon: Globe },
  location: { label: "Location", icon: MapPin },
  classroom: { label: "Classroom", icon: GraduationCap },
  league: { label: "League", icon: Trophy },
  season: { label: "Season", icon: CalendarRange },
} satisfies Record<OrgUnitType, { label: string; icon: LucideIcon }>;

export const ORG_UNIT_TYPE_OPTIONS = (
  [
    "org",
    "division",
    "department",
    "team",
    "region",
    "location",
    "classroom",
    "league",
    "season",
  ] as const satisfies readonly OrgUnitType[]
).map((value) => ({ value, ...ORG_UNIT_TYPE_LABELS[value] }));

function isOrgUnitType(value: string): value is OrgUnitType {
  return Object.prototype.hasOwnProperty.call(ORG_UNIT_TYPE_LABELS, value);
}

/** An org unit type's label; a type this console does not know is shown as identity sent it. */
export function orgUnitTypeLabel(type: string): string {
  return isOrgUnitType(type) ? ORG_UNIT_TYPE_LABELS[type].label : type;
}
